import { render, staticRenderFns } from "./paymentMethodForm.vue?vue&type=template&id=b3563580"
import script from "./paymentMethodForm.vue?vue&type=script&lang=js"
export * from "./paymentMethodForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports